// @ts-nocheck
import * as React from 'react';
import debounce from 'lodash.debounce';
import { debounceConstants } from 'commons/constants';
import { useDispatch, useSelector } from 'react-redux';
import articlesActions from 'ducks/articles/actions';
import NooderaSearchBar from 'components/NooderaSearchBar/index';
import { ImagePickerWrapper, ImagePickerContainer } from './ImagePicker.styles';
import type { ImagePickerProps } from './ImagePicker.types';
import ImagePickerResults from './ImagePickerResults/index';

const { GET_ARTICLE_COVER_IMAGES_DELAY } = debounceConstants;

const ImagePicker = ({
  onSelectImage,
  selectedPhoto,
  placeholder,
  className,
}: ImagePickerProps): React.ReactElement<any> => {
  const dispatch = useDispatch();
  const coverImagesPage = useSelector((state) => state.articles.coverImagesPage) ?? 1;
  const coverImages = useSelector((state) => state.articles.coverImages) ?? null;
  const isLoading = useSelector((state) => state.articles.isLoadingCoverImages) ?? false;
  const [searchTerm, setSearchTerm] = React.useState('');
  const [internalSelectedPhoto, setInternalSelectedPhoto] = React.useState(selectedPhoto ?? null);
  const getUnsplashImages = React.useCallback(
    (search, page) => {
      dispatch(articlesActions.getArticleCoverImagesRequest(search, page));
    },
    [dispatch],
  );

  const selectPhotoAndSendToParent = (image: Record<string, any> | null) => {
    onSelectImage(image);
    setInternalSelectedPhoto(image);
  };

  const selectPhoto = (image: Record<string, any>): void => {
    if (!internalSelectedPhoto || internalSelectedPhoto.id !== image.id) {
      selectPhotoAndSendToParent(image);
    } else {
      selectPhotoAndSendToParent(null);
    }
  };

  const onSearchOtherPage = (searchPage = 1): void => {
    getUnsplashImages(searchTerm, searchPage);
  };

  const updateSearchTermAndSearch = (search: string): void => {
    setSearchTerm(search);
  };

  React.useEffect(() => {
    if (searchTerm.length > 2) {
      debounce(() => {
        getUnsplashImages(searchTerm, 1);
      }, GET_ARTICLE_COVER_IMAGES_DELAY)();
    }
  }, [searchTerm, getUnsplashImages]);

  const renderDialogChoose = (): React.ReactElement<any> => (
    <>
      <NooderaSearchBar
        id='image-picker-search'
        placeholder={placeholder}
        onInputChange={(e) => updateSearchTermAndSearch(e.target.value)}
      />
      <ImagePickerResults
        isLoading={isLoading}
        searchTerm={searchTerm}
        selectedPhoto={internalSelectedPhoto}
        coverImages={coverImages}
        coverImagesPage={coverImagesPage}
        onSearchOtherPage={onSearchOtherPage}
        onSelectPhoto={selectPhoto}
      />
    </>
  );

  return (
    <ImagePickerWrapper className={className}>
      <ImagePickerContainer>{renderDialogChoose()}</ImagePickerContainer>
    </ImagePickerWrapper>
  );
};

export default ImagePicker;
